import { gql } from '@apollo/client';

export const FETCH_EMAIL_LOGS = gql`
query FetchEmailLog {
    fetchEmailLog {
        data {
            email_log {
                content
                created_at
                error_message
                id
                receiver
                status
                subject
                title
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;


